import React, {Component} from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import qr from 'qr-encode'

import {Page, Preload} from '../components'

import '../css/page/GiftReceiveSuccessPage.css'
import GiftSuccess from '../images/gift-success.png'


class GiftReceiveSuccessPage extends Component {
    constructor() {
        super()
        this.state = {
            initialized: false,
            lectures: [],
        }
    }

    componentDidMount() {
        const _this = this
        const {channel_id} = this.props.params

        axios.get(`/api/channel/${channel_id}/gift_lectures`).then(res => {
            if (res.data.code !== 0) {
                _this.setState({initialized: true})
                _this.page.showAlert(res.data.msg)
            } else {
                _this.setState({initialized: true, lectures: res.data.data.lectures})
            }
        })
    }

    render() {
        const {initialized, lectures} = this.state
        const {account} = this.props
        const {channel_id} = this.props.params

        if (!initialized) {
            return <Preload/>
        }

        return (
            <Page parent={this}>
                {account.subscribed &&
                    <div className='gift-receive-success-page'>
                        <img className='gift-success-image' src={GiftSuccess}/>

                        <div className='gift-tips-container'>
                            <div className='gift-tips-content text-center'>
                                <p>温馨提示：</p>
                                <p>新人礼包课程自领取日起，</p>
                                <p>有效期10天，请尽快体验哦</p>
                            </div>
                            <p className='gift-tips-text'>可在【首页】–【我的礼包】中查看</p>
                        </div>

                        <div className='gift-btn'>
                            <a href={`/channel/${channel_id}`} className='weui-btn weui-btn_primary'>马上体验</a>
                        </div>

                        <div className='gift-lectures'>
                            <p className='gift-lectures-text'>礼包课程详情</p>
                            <div className="weui-panel weui-panel_access">
                                <div className="weui-panel__bd">
                                    {lectures.map((item, index) => (
                                        <a href={`/lecture/${item.id}`} className="weui-media-box weui-media-box_appmsg" key={index}>
                                            <div className="weui-media-box__hd background-image">
                                                <img className="weui-media-box__thumb" src={item.avatar} alt=""/>
                                            </div>
                                            <div className="weui-media-box__bd overflow-hidden">
                                                <h4 className="weui-media-box__title" style={{fontSize: "14px"}}>{item.name}</h4>
                                                <p className="weui-media-box__desc liveroom-name text-ellipsis">{item.liveroom_name}</p>
                                                <p className="weui-media-box__desc listener-num" style={{fontSize: "12px", float: "left"}}>
                                                    {item.popular}人参与
                                                </p>
                                            </div>
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {!account.subscribed &&
                    <div className='gift-receive-success-page'>
                        <img className='gift-success-image' src={GiftSuccess}/>

                        <div className='gift-content'>
                            <div className="gift-qrcode">
                                <img src={qr('http://weixin.qq.com/q/02WvcU44WIds010000007D')} alt="" style={{width: '35%'}}/>
                            </div>
                            <div className="gift-tips">长按扫码，接收最新活动资讯</div>
                        </div>

                        <div className='gift-bottom'>
                            <p className='gift-bottom-text'>可在【首页】-【我的礼包】中查看</p>
                            <p className='gift-bottom-tips'>温馨提示：新人礼包自领取日起，有效期为10天，请尽快体验哦！</p>
                        </div>
                    </div>
                }
            </Page>
        )
    }
}

export default connect((state) => ({
    account: state.account
}))(GiftReceiveSuccessPage)


// WEBPACK FOOTER //
// ./src/pages/GiftReceiveSuccessPage.js